<mat-form-field
  *ngIf="dateControl"
  appearance="outline"
  ngClass="ks-input-{{ size }} ks-input-{{ color }}"
  [class.ks-input-no-space]="!errors.length"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    #input
    matInput
    [id]="id"
    [owlDateTime]="picker"
    [selectMode]="isRange ? 'range' : 'single'"
    [min]="min"
    [max]="max"
    [placeholder]="placeholder"
    [formControl]="dateControl"
    [required]="required"
    [readonly]="readonly"
    (focus)="focused.emit()"
    (blur)="blurred.emit()"
  />
  <div matSuffix [owlDateTimeTrigger]="picker" class="ks-calendar-toggle">
    <span inlineSVG="assets/icons/Calendar.svg"></span>
  </div>
  <owl-date-time
    #picker
    [pickerType]="type === 'date' ? 'calendar' : type === 'time' ? 'timer' : 'both'"
    [hour12Timer]="true"
    [disabled]="dateControl.disabled"
    panelClass="ks-calendar-{{ color }}"
  ></owl-date-time>
  <mat-error *ngIf="errors.length" class="ks-input-error">
    <ng-container *ngFor="let error of errors">
      <span
        *ngIf="dateControl.hasError(error.validation) && (dateControl.dirty || dateControl.touched)"
        class="ks-text-1lns"
      >
        <span inlineSVG="assets/icons/Error.svg" class="ks-input-error__icon"></span
        >{{ error.message }}
      </span>
    </ng-container>
  </mat-error>
</mat-form-field>
